// eslint-disable-next-line import/prefer-default-export
export const eventWorldcupInfo = {
    listPrize: [
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money.jpg',
            title: '2 TRIỆU',
            numberPrize: 100,
            numberReal: 100,
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-win.jpg',
            title: 'THẮNG',
            text: '+3 ĐIỂM',
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-lose.jpg',
            title: 'THUA',
            text: '0 ĐIỂM',
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-draw.jpg',
            title: 'HÒA',
            text: '+1 ĐIỂM',
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money.jpg',
            title: '50K',
            numberPrize: 6000,
            numberReal: 6000,
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-lucky.jpg',
            title: 'LUCKY',
            text: 'Chúc may mắn',
            type: 1
        },
        {
            type: 0,
            thumb: '/assets/img/event/worldcup/tabs/prize-special.png'
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money-2.jpg',
            title: '10K',
            numberPrize: 10000,
            numberReal: 10000,
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money.jpg',
            title: '300K',
            numberPrize: 1000,
            numberReal: 1000,
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-refund.jpg',
            title: 'HOÀN TRẢ 3%',
            numberPrize: 100,
            numberReal: 100,
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money.jpg',
            title: '1 triệu',
            numberPrize: 300,
            numberReal: 300,
            type: 1
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money-2.jpg',
            title: '500K',
            numberPrize: 500,
            numberReal: 500,
            type: 1

        },
        {
            thumb: '/assets/img/event/worldcup/tabs/prize-money.jpg',
            title: '100K',
            numberPrize: 3000,
            numberReal: 3000,
            type: 1
        }
    ],
    listInfoRule: [
        {
            icon: '/assets/img/event/worldcup/tabs/step-1.svg',
            content: [
                {
                    text: 'Đăng nhập mỗi ngày nhận <span>1 lượt quay</span> ( tối đa 1 lượt/24h).'
                },
                {
                    text: 'Người chơi NẠP tối thiểu <span>2,000,000 VND</span> sẽ được nhận 1 lượt quay.'
                },
                {
                    text: 'Tham gia cược tối thiểu <span>4,000,000 VND</span> sẽ nhận được 1 lượt quay.'
                }
            ]
        },
        {
            icon: '/assets/img/event/worldcup/tabs/step-2.svg',
            content: [
                {
                    text: 'Lượt chơi sẽ được dùng để tham gia chương trình.'
                },
                {
                    text: '1 lượt chơi, khách hàng sẽ được quay 1 lượt.'
                },
                {
                    text: 'Tương ứng mỗi lượt quay, khách hàng sẽ có cơ hội nhận các giải tiền mặt và sưu tập tích điểm đua top săn hũ'
                },
                {
                    text: 'Sưu tập Trận Thắng và nằm trong Top người chơi, khách hàng sẽ trúng các giải thưởng trị giá cao.'
                },
                {
                    text: 'Trận thắng: <span> +3 điểm.</span>'
                },
                {
                    text: 'Trận hòa: <span> +2 điểm.</span>'
                },
                {
                    text: 'Trận thua: <span> +1 điểm.</span>'
                },
                {
                    text: 'Top 10 người chơi có số điểm cao nhất chia đều giải thưởng <span>JACKPOTS.<span />'
                },
                {
                    text: 'Hoàn trả 3% cho 1 Vé thua kế tiếp <span>( Áp dụng cho cược Sport và không cộng dồn với hoàn trả 1,58% - tối đa 1 triệu )<span />'
                }
            ]
        },
        {
            icon: '/assets/img/event/worldcup/tabs/step-3.svg',
            content: [
                {
                    text: 'Điều kiện rút thưởng:'
                },
                {
                    text: 'Hoàn thành 1 vòng cược doanh thu.'
                },
                {
                    text: 'Khách hàng có TKNH Chính Chủ mới được rút.'
                },
                {
                    text: 'Vé nạp và vé cược phải hợp lệ mới được tính trúng giải. Trong trường hợp vé không hợp lệ, Quý khách dùng lượt quay đó để quay trúng giải thì giải thưởng sẽ bị thu hồi.'
                },
                {
                    text: 'Chương trình sẽ hủy toàn bộ số điểm sưu tập, tiền thưởng của Quý khách nếu phát hiện có vé cược gian lận.'
                }
            ]
        }
    ],
    listEarnTurn: [
        {
            thumb: '/assets/img/event/worldcup/tabs/earn-login.png',
            func: 'login',
            title: 'Đăng nhập',
            isShowNotLogin: true
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/earn-deposit.png',
            title: 'Nạp tiền ngay',
            func: 'deposit'
        },
        {
            thumb: '/assets/img/event/worldcup/tabs/earn-bet.png',
            title: 'Cược ngay',
            func: 'bet'
        }
    ],
    conditionList: [
        {
            text: 'Giải thưởng tiền mặt sẽ được cộng trực tiếp vào tài khoản tối đa 24h sau khi quay trúng.'
        },
        {
            text: 'Danh sách trúng giải đặc biệt sẽ được công bố sau ngày <span>31/01/2023</span>.'
        },
        {
            text: 'Giải thưởng chỉ được duyệt rút về các tài khoản ngân hàng đã đăng ký <span>NGÂN HÀNG CHÍNH CHỦ</span> (Tài khoản ngân hàng Nạp và Rút đã được hệ thống xác nhận).'
        },
        {
            text: 'Các quy định chung về khuyến mãi, bảo mật, điều khoản và miễn trách nhiệm của Oxbet sẽ được áp dụng.'
        }
    ],
    note: 'Oxbet sẽ tiến hành xem xét quá trình đặt cược của Người chơi và trong trường hợp phát hiện có bất kỳ một hành vi nào lạm dụng tiền thưởng khuyến mãi, chúng tôi có quyền hủy bỏ tất cả số tiền thắng cược và giải thưởng trúng được đã nhận từ các vé cược - Vi phạm như đặt cược hai bên , cược chéo , cược gấp thấp trong cùng một trận/thị trường, đặt cược nhiều cho cùng một kết quả trong cùng một trận/thị trường.  Và các cược hòa, cược hủy , cược kiểu HK tỷ lệ dưới 0.65 (tương đương cho các kiểu cược khác như Malay odd dưới 0.65; Indo odd dưới -1.53; và Dec odd dưới 1.65) sẽ không được tính vào tổng tiền đặt cược.'
};
